import { post } from "../base.ehq.model";
import { deserialize } from "../base.serializer";
import { serialize } from "./registered-user.serializer";

export const getRegisteredUserToken = async (token, baseUrl, body) => {
  const queryPath = `${baseUrl}/tokens`;
  try {
    const serializedBody = serialize(body);
    let res = await post(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
